import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { Unavailability } from '@thro-types/leihbar';

import { format } from 'date-fns';

import { hasUnavailabilitiesForSelectedDay } from 'app/containers/LeihBar/date.helper';
import { Colors } from 'utils/colors';

interface CustomPickersDayProps {
  day: Date;
  selectedDays: Date[];
  pickersDayProps: PickersDayProps<Date>;
  unavailabilities: Unavailability[] | undefined;
  articleCount?: number;
}

export const CustomPickersDay = ({
  day,
  pickersDayProps,
  unavailabilities,
  articleCount
}: CustomPickersDayProps) => {
  const getBackgroundColor = () => {
    const formattedDay = format(day, 'yyyy-MM-dd');
    if (pickersDayProps.disabled || articleCount === 0 || unavailabilities === undefined) {
      return undefined;
    }
    if (hasUnavailabilitiesForSelectedDay(formattedDay, unavailabilities)) {
      return Colors.partiallyAvailableColor;
    }
    return Colors.availableColor;
  };

  const { key, ...restProps } = pickersDayProps;

  return (
    <PickersDay
      {...restProps}
      day={day}
      style={
        pickersDayProps.disabled
          ? { backgroundColor: getBackgroundColor() }
          : { backgroundColor: getBackgroundColor(), fontWeight: 550 }
      }
      selected={false}
    />
  );
};
